import request from './services/axios.js'

export default {
  // 新增
  setLinkWords: (params) => {
    return request({
      data: params,
      url: 'ebook/linkWork/add',
      method: 'post'
    })
  },
  //获取刊物列表接口http://www-fxcloud.devx.fzyun.io/linkWork/getLinkWorks?pageNo=&pageSize=&username=
  getLinkWorks: (params) => {
    return request({
      params,
      url: 'ebook/linkWork/getLinkWorks',
      method: 'get'
    })
  },
  // 删除列表  http://www-fxcloud.devx.fzyun.io/linkWork/del?ids=3,7,8
  delLinkWorks: (params) => {
    return request({
      params,
      url: 'ebook/linkWork/del',
      method: 'get'
    })
  },
  // 编辑作品 http://www-fxcloud.devx.fzyun.io/linkWork/edit
  editLinkWorks: (params) => {
    return request({
      data: params,
      url: 'ebook/linkWork/edit',
      method: 'post'
    })
  }
}
